import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'
import { withKnobs, number, text } from '@storybook/addon-knobs/react'

import Grid from '@material-ui/core/Grid'

import Paper from 'components/Paper'
import AccountInfo from 'components/AccountInfo'

const stories: {
  color: 'accent' | 'primary' | 'secondary'
}[] = [{
  color: 'accent',
}, {
  color: 'primary',
}, {
  color: 'secondary',
}]

storiesOf('AccountInfo', module)
  .addDecorator(withKnobs)
  .add('default', () => {
    const props = {
      balance: [{ value: number('Balance', 0, { min: 0, max: 99999, step: 1000 }) }],
      badgeContent: number('Badge', 0, { min: 0, max: 99, step: 1 }),
      userName: text('Username', 'Jane Doe'),
      onClick: action('Na!'),
    }

    return (
      <Grid spacing={2} justify="center" container>
        {
          stories.map((story, i) => (
            <Grid key={`story-${i}`} item>
              <Paper color={story.color} style={{ padding: 16 }}>
                <AccountInfo {...props} />
              </Paper>
            </Grid>
          ))
        }
      </Grid>
    )
  })
